import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import prismIntegrationService from '../../services/PrismIntegration/PrismIntegrationService'

const initialState = []

export const createIssueType = createAsyncThunk(
  'issueType/create',
  async (payload) => {
    const res = await prismIntegrationService.createIssueType(payload)
    return res.data
  },
)



export const getCategories = createAsyncThunk(
  'categories/',
  async (payload) => {
    const res = await prismIntegrationService.getCategories()
    return res.data
  },
)

export const filterPropertyMgmt = createAsyncThunk(
  'propertyMgmt/filter',
  async (payload) => {
    const res = await prismIntegrationService.filterPropertyMgmt(
      payload
    )
    return res.data
  },
)

export const propertyList = createAsyncThunk('/propertylist' , async(payload) => {
  const res = await prismIntegrationService.propertyList()
  return res.data
})

export const getIssuestypes = createAsyncThunk('/issueTypes/list' , async() => {
  const res = await prismIntegrationService.getIssueTypes()
  return res.data;
})

export const validateCredentials = createAsyncThunk('/validate' , async(payload) => {
  const res = await prismIntegrationService.validateCredentials(payload)
  return res.data;
})

const prismIntegrationSlice = createSlice({
  name: 'prismIntegration',
  initialState,
  extraReducers: {
    [getCategories.fulfilled]: (state, action) => {
      if (action.payload.code === '') {
        return action.payload.data
      } else {
        return []
      }
    },
  },
})

const { reducer } = prismIntegrationSlice
export default reducer
